import Business from '@constants/Business'
import salonLogo from '@utils/links/salonLogo'
import salonLink from '@utils/links/salonLink'
import { makeItemListLdSchema } from 'src/seo/jsonld/server/makeItemListLdSchema'
import { FIRM_BASE_PAGE } from '@constants/routes'

const POSTAL_CODE = /\b\d{2}-\d{3}\b/

// Adres firmy zapisany jednym tekstem („Armii Krajowej 18 30-150 Kraków”, także z nowymi wierszami): ulica, kod
// pocztowy i miejscowość po kodzie; bez kodu — cały tekst jako ulica, miejscowość z pola miasta.
export function postalAddress (street, city) {
    const text = String(street || '').replace(/\s+/g, ' ').trim()
    const code = text.match(POSTAL_CODE)
    const before = code ? text.slice(0, code.index).replace(/[\s,]+$/, '') : text
    const after = code ? text.slice(code.index + code[0].length).replace(/^[\s,]+/, '') : ''
    if (!before && !after && !city) return undefined
    return {
        '@type': 'PostalAddress',
        'streetAddress': before || undefined,
        'postalCode': code ? code[0] : undefined,
        'addressLocality': after || city || undefined,
        'addressCountry': 'PL',
    }
}

// Wizytówka: AutoDealer (nazwa wyświetlana, nazwa prawna jako alternateName, logo, adres, punkt na mapie, Facebook;
// bez telefonu i e-maila — tylko przez „Pokaż numer” / „Pokaż e-mail”), ItemList kart strony i okruszki jak na stronie.
// Bez pustych pól.
export default function salonPage ({ firm, offers, map }) {
    const url = salonLink(firm.subdomain)
    const logo = firm.hasLogo ? Business.host + salonLogo(firm._id) : undefined
    const dealer = {
        '@type': 'AutoDealer',
        '@id': `${url}#firma`,
        'name': firm.name || firm.legal,
        'alternateName': firm.legal && firm.legal !== firm.name ? firm.legal : undefined,
        'url': url,
        'image': logo,
        'logo': logo,
        'address': postalAddress(firm.street, firm.city),
        'geo': map?.kind === 'point' ? { '@type': 'GeoCoordinates', 'latitude': map.lat, 'longitude': map.lng } : undefined,
        'sameAs': firm.facebook ? [firm.facebook] : undefined,
    }
    const list = makeItemListLdSchema(offers?.ads)
    if (list) { list['@id'] = `${url}#oferta`; list.name = `Oferta: ${firm.name || firm.legal}` }
    const crumbs = {
        '@type': 'BreadcrumbList',
        'itemListElement': [['Baza firm', Business.host + FIRM_BASE_PAGE], [firm.name || firm.legal, url]]
            .map(([name, item], i) => ({ '@type': 'ListItem', 'position': i + 1, 'name': name, 'item': item })),
    }
    return { '@context': 'https://schema.org', '@graph': [dealer, list, crumbs].filter(Boolean) }
}
